import React, {Component} from "react";
import {
    Col,
    Row,
	InputGroup,
	InputGroupAddon,
    Input
} from "reactstrap";

import Registry from "../../Utils/Registry";
import TYPagination from "../TYPagination";
import TYDatePicker from "../TYDatePicker";
import Helpers from "../../Utils/Helpers";
import { InvoiceV2Service } from "../../services";
import EnterpriseInvoicesV2Table from "./Invoices/InvoicesV2Table";
import Variables from "../../Utils/Variables";


class EnterpriseInvoicesV2 extends Component {
    constructor(props) {
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            loading: false,
            invoices: [],
            per_page: 8,
            page: 1,
            total_pages: 1,
            showFilters: false,
            filters: {}
        };
    }

    componentDidMount() {
        this.user = Registry.observe(this, "user", user => {
            this.user = user;
			this.loadInvoices();
        });

        if(this.user)
            this.loadInvoices();
    }

    changePage = page => this.loadInvoices(page);

    loadInvoices = (page=1) => {
        this.setState({
            loading: true,
            invoices: []
        });

        if(!this.user)
            return;

        let opt = {
            page,
            orderBy: "-number",
            ...Object.fromEntries(Object.entries(this.state.filters).filter(([k, v]) => v !== "null"))
        };

        InvoiceV2Service.GetList(opt)
            .then(({results, per_page, page, total_pages}) => this.setState({
                loading: false,
                invoices: results,
                per_page: per_page,
                page: page,
                total_pages: total_pages
            }))
            .catch(() => this.setState({ loading: false }));
    };

	toggleFilters = () => this.setState({
        showFilters: !this.state.showFilters,
        filters: {}
    }, () => {
        if(!this.state.showFilters)
            this.loadInvoices();
    });

    setFilter = (key, value) => this.setState({filters: {...this.state.filters, [key]: value}}, this.loadInvoices);

    render() {
        return (
            <Row>
                <Col xs="12" sm="12" lg="12" xl="8">
                    <div className="d-flex justify-content-between marg-b-20">
    					<h2 className="ty-subtitle align-self-center">Vos factures V2 (Beta)</h2>
                        <h3></h3>
                    </div>
                    <div className="table-filters-line">
                        <div className="table-filter-search">
							<InputGroup>
								<Input
									placeholder="Num de facture, .."
									className="no-focus advanced-search-input border-r-0"
                                    value={this.state.filters.id}
                                    onChange={e => this.setFilter('numbers', e.target.value)}
								/>
								<InputGroupAddon className="advanced-search-filter" onClick={this.toggleFilters} addonType="append">
									<div style={{marginTop: '13px', paddingRight: '10px'}}>{this.state.advanced_search ? "Fermer" : "Filtres"}</div>
								</InputGroupAddon>
							</InputGroup>
                        </div>

						<div className="table-filter-pagination">
							<TYPagination
								page={this.state.page-1}
								total_pages={this.state.total_pages}
								onPageChanged={this.changePage}
							/>
                        </div>
                    </div>

                    {
                        this.state.showFilters ?
                            <div className="advanced-filter-container">
								<div className="advanced-filter">
									<div className="advanced-filter-label">Date</div>
									<div className="flex-line">
                                        <TYDatePicker onDatePicked={date => this.setFilter('createdAtFrom', `${Helpers.formatDate(date, 'YYYY-MM-DD')}T00:00:00Z`)} />
										<div className="flex-centered pad-10">au</div>
                                        <TYDatePicker onDatePicked={date => this.setFilter('createdAtTo', `${Helpers.formatDate(date, 'YYYY-MM-DD')}T23:59:59Z`)} />
									</div>
								</div>
								<div className="advanced-filter">
									<div className="advanced-filter-label">Paiement</div>
									<div className="flex-line">
										<select className="form-control" onChange={e => this.setFilter('paymentStatus', e.target.value)}>
                                            <option value="null">S&eacute;l&eacute;ctionner ...</option>
                                            {
                                                Variables.invoiceV2PaymentStatus.map(({value, label}, i) => <option key={`filter-opt-${i}`} value={value}>
                                                    { label }
                                                </option>)
                                            }
                                        </select>
									</div>
								</div>
                            </div>
                            : null
                    }

                    <EnterpriseInvoicesV2Table
                        loading={this.state.loading}
                        invoices={this.state.invoices}
                    />
                </Col>
            </Row>
        )
    }
}

EnterpriseInvoicesV2.defaultProps = {
};

export default EnterpriseInvoicesV2;



// WEBPACK FOOTER //
// ./src/components/Enterprise/InvoicesV2.js